import { MultilangContent } from './multilang-content';
import { Section } from './section';

export class Block {
  public id: number;
  public type: 'pages' | 'slider' | 'news';
  public names: MultilangContent;
  public created_at: string;
  public updated_at: string;
  public name: string;
  public rows: number;
  public columns: number;
  public sections: Section[];

  public get gridTemplateClasses() {
    return `grid-rows-${this.rows} grid-columns-${this.columns}`;
  }

  constructor(data: Block) {
    Object.assign(this, data);
    if (data.sections) {
      this.sections = this.sections.map((section) => new Section(section));
    }
  }
}
